import type {
  MRT_PaginationState,
  MRT_TableOptions,
  MRT_RowData,
} from '@ouster/webviz-react-components';

/* 
  Helper to create pagination config for table component
*/
export const createPaginationConfig = <T extends MRT_RowData>(
  meta: { totalCount?: number } | undefined,
  pagination: MRT_PaginationState
): Pick<
  MRT_TableOptions<T>,
  'muiBottomToolbarProps' | 'paginationDisplayMode'
> => ({
  muiBottomToolbarProps: {
    sx: {
      '& .MuiBox-root': {
        left: '0px',
        justifyContent: 'center',
      },
      // Hide pagination when there's only one page or less
      display: (meta?.totalCount ?? 0) <= pagination.pageSize ? 'none' : 'flex',
    },
  },
  paginationDisplayMode: 'pages',
});

export const hasUserSelectionOnTable = () => {
  const selection = window.getSelection();
  if (selection && selection.toString().length > 0) {
    return true;
  }

  return false;
};
